var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"container-fluid\"> <winres-service-select-item ng-repeat=\"item in $ctrl.items track by item.id\" item=\"item\" ng-model=\"$ctrl.values[item.id]\" ng-change=\"$ctrl.read(item.id)\" ng-disabled=\"$ctrl.isDisabled(item.id)\" radio=\"$ctrl.isSingle()\"> </winres-service-select-item> </div>";
var id1="winresServiceSelectItems.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresServiceSelectItems/winresServiceSelectItems.html
// module id = 464
// module chunks = 2